import { useEffect } from 'react';

/**
 * Custom hook that listens for the Escape key press and executes a callback function.
 *
 * This hook adds a global keydown event listener to the window and calls the provided
 * callback function when the Escape key is pressed. The event listener is automatically
 * cleaned up when the component unmounts or the callback changes.
 */
export function useEscapeKey(callback: () => void) {
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        callback();
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [callback]);
}
